/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BBusinessModelTypes } from './businessModelTypes';
import { B2BCalendarServiceTypeDto } from './calendarServiceTypeDto';


export interface B2BCalendarShopDto { 
    id?: number;
    name?: string | null;
    addressDisplay?: string | null;
    isOpen?: boolean;
    orderCount?: number;
    services?: Array<B2BCalendarServiceTypeDto> | null;
    businessType?: B2BBusinessModelTypes;
    deliveryLocationEnabled?: boolean;
    mealAtPlaceEnabled?: boolean;
    mealAtPlaceDeliveryFromTime?: string | null;
    mealAtPlaceDeliveryToTime?: string | null;
    timeSlotDuration?: number | null;
    mealAtPlaceLocations?: string | null;
    notesEnabled?: boolean;
}
export namespace B2BCalendarShopDto {
}


